import { useRef } from "react";
import { Link } from "react-router-dom";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { poolName } from "../../../../enviroments";
import { truncateText } from "../../../../app/utils/functions/stringMethods";
import { requestWalletConnection } from "../../../../app/utils/requestWalletConnection";
import { useAccount } from "../../../../app/hooks/useAccount";
import { useAppContext } from "../../../../app/hooks/useAppContext";
import { useAppSelector, useAppDispatch } from "../../../../states/hooks";
import {
    actions,
    selectBookmarkedMiner,
    selectIsWalletConnected,
} from "../../../../states/appState";

import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import SearchIcon from "@mui/icons-material/Search";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import VerifiedIcon from "@mui/icons-material/Verified";
import SpeedIcon from "@mui/icons-material/Speed";
import DnsIcon from "@mui/icons-material/Dns";

export const WelcomeSection = () => {
    const { t } = useTranslation();
    const { accountId } = useAccount();
    const { isUnsafeWebsite } = useAppContext();
    const { setSearchMiner } = actions;
    const bookmarkedMinerID = useAppSelector(selectBookmarkedMiner);
    const isWalletConnected = useAppSelector(selectIsWalletConnected);
    const dispatch = useAppDispatch();
    const searchBoxRef = useRef(null);

    const onSubmit = (e: any) => {
        e.preventDefault();
        // @ts-ignore
        const value = searchBoxRef.current.value.trim();
        if (!value) return;

        dispatch(setSearchMiner(value));
    };

    const handleClick = () => {
        if (!isWalletConnected || !accountId) {
            requestWalletConnection();
            return;
        }

        dispatch(setSearchMiner(accountId));
    };

    return (
        <Grid container className="smHomeTop">
            <Paper
                className="smWelcomeHero"
                sx={{
                    width: "100%",
                    borderRadius: 0,
                    overflow: "hidden",
                }}
            >
                <Grid className="smHeroInner" container>
                    <Grid item xs={12} lg={6} className="smHeroCopy">
                        <Typography component="p" className="smEyebrow">
                            Live Signum Pool · Deutschland
                        </Typography>
                        <Typography
                            component="h1"
                            variant="h3"
                            fontWeight={950}
                            width="100%"
                            className="smHeroTitle"
                        >
                            {isMobile
                                ? truncateText(poolName, 32)
                                : poolName}
                        </Typography>

                        {!bookmarkedMinerID && (
                            <Grid container direction="column">
                                <Grid item>
                                    <Typography
                                        variant="h6"
                                        fontWeight={400}
                                        className="smHeroLead"
                                        gutterBottom
                                    >
                                        Transparenter Signum Mining Pool mit Live-Daten, HDD-/SSD-Mining, klaren Kennzahlen und direktem Einstieg für Miner.
                                    </Typography>
                                </Grid>

                                <Grid item className="smHeroActions">
                                    <Link to="/start-mining">
                                        <Button className="smMiningButton" variant="contained">
                                            {t("startMining")}
                                        </Button>
                                    </Link>
                                    <Button
                                        component="a"
                                        href="https://signamining.de"
                                        target="_blank"
                                        rel="noopener"
                                        className="smHeroGhost"
                                    >
                                        Mehr Infos
                                    </Button>
                                </Grid>

                                <Grid item className="smHeroPills">
                                    <span><VerifiedIcon /> Live API</span>
                                    <span><SpeedIcon /> PoC+ Mining</span>
                                    <span><DnsIcon /> Pool Monitoring</span>
                                </Grid>
                            </Grid>
                        )}
                    </Grid>

                    <Grid item xs={12} lg={6} className="smHeroVisual">
                        <img
                            className="smWelcomeBanner"
                            src="/hero.png"
                            alt="SignaMining.de Hero"
                        />
                    </Grid>
                </Grid>
            </Paper>

            <Grid
                container
                item
                mx="auto"
                maxWidth={660}
                className="smSearchWrapper"
            >
                <Paper
                    component="form"
                    className="smSearchBox"
                    onSubmit={onSubmit}
                    elevation={0}
                    sx={{
                        width: "100%",
                        px: { xs: 1, lg: 2 },
                        py: 1,
                        display: "flex",
                        alignItems: "center",
                        border: 1,
                        borderColor: "divider",
                    }}
                >
                    <InputBase
                        inputRef={searchBoxRef}
                        sx={{
                            fontSize: { xs: 14, lg: 18 },
                            ml: 1,
                            flex: 1,
                        }}
                        placeholder={t("yourSignumAddressOrAccountName")}
                    />

                    {!isUnsafeWebsite && (
                        <Tooltip
                            title={`${t(
                                isWalletConnected
                                    ? "viewMinerDetails"
                                    : "connectWallet"
                            )}`}
                            arrow
                        >
                            <Button
                                variant="contained"
                                color="error"
                                className="smWalletSearchBtn"
                                onClick={handleClick}
                            >
                                <AccountBalanceWalletIcon fontSize="large" />
                            </Button>
                        </Tooltip>
                    )}

                    <Button
                        type="submit"
                        variant="contained"
                        className="smSearchSubmitBtn"
                        aria-label="search"
                    >
                        <SearchIcon fontSize="large" />
                    </Button>
                </Paper>
            </Grid>
        </Grid>
    );
};
